import TrialsServiceClient from "@seneca/trials-service-client";
import { FeatureType } from "@seneca/trials-service-client/dist/types";

import errorHandler from "services/trialsService/errorHandler";

import { fetchTrialsActionFactory, receivePremiumTrials } from "../state";

export const makeStartPremiumTrial = (getClient: () => TrialsServiceClient) => {
  return fetchTrialsActionFactory({
    requestFunction: type => getClient().startPremiumTrial(type),
    storeAction: receivePremiumTrials,
    errorHandler
  });
};

export const makeStartInviteParentsExamQuestionsPremiumTrial = (
  getClient: () => TrialsServiceClient
) => {
  const startPremiumTrial = makeStartPremiumTrial(getClient);
  return () => startPremiumTrial(FeatureType.INVITE_PARENTS_EXAM_QUESTIONS);
};
